import { IEventSystem } from "@dhx/ts-common/events";
import { IField, IFilterMeta, PivotEvents } from "../types";
import { DateFilter } from "./DateFilter";
import { Filter } from "./Filter";

import { getUniqueFieldData } from "../helpers";

export function getFilterHandler(meta: IFilterMeta, field: IField) {
	return function(item: any) {
		if (field.type === "date") {
			item = item.getTime();
		}
		return meta.values.includes(item);
	};
}

export class Filters {
	events: IEventSystem<PivotEvents>;
	private _filter: any;

	constructor(events: IEventSystem<PivotEvents>) {
		this.events = events;
	}

	getFilter(item: IField, coords, data: any[], oldMeta: IFilterMeta) {
		if (!data) return;
		const uniqueData = getUniqueFieldData(item, data);
		item.type = item.type || this._getFieldType(uniqueData) || "string";

		if (this._filter && this._filter.isVisible() && this._filter.getItem() !== item) {
			this._filter.hide();
			this._filter = null;
		}
		if (!this._filter) {
			this._filter = this._getFilter(item.type);
			this._filter.setMeta(item, oldMeta, uniqueData);
			this._filter.show(coords);

			this._filter.config.events.on("filterApply", () => {
				this._filter = null;
			});
			this._filter.config.events.on("filterCancel", () => {
				this._filter = null;
			});
		}
	}

	protected _getFilter(type: string) {
		switch (type) {
			case "number":
			case "string":
				return new Filter({ events: this.events });
			case "date":
				return new DateFilter({ events: this.events });
			default:
				break;
		}
	}

	protected _getFieldType(fieldData: any[]) {
		if (isNaN(fieldData[0])) {
			return typeof fieldData[0];
		} else {
			return "number";
		}
	}
}
